export const Topic = {
  Video: "VIDEO",
  ProductTest: "PT",
  KnowledgeAssessment: "KA",
  PreCaution: "PRECAUTION",
  RiskAwareSignature: "RISK",
};

export const PreTestSection = {
  PrimaryMarket: "primary",
  SecondaryMarket: "secondary",
};
